import { type Availability, type MaterialSubject } from '@/platform/materials/extraction'

/**
 * The subject of a material is the learner's explicit choice: there is no
 * default (D-21). "Another subject" is a valid answer and means the material
 * is not sent anywhere. The server checks the subject again.
 */
export type SubjectChoice = MaterialSubject | 'other'

/** The subject a choice may be sent as, or null (none chosen, other, or not offered). */
export function sendableSubject(
  reader: { kind: 'checking' } | Availability,
  choice: SubjectChoice | null,
): MaterialSubject | null {
  if (!('available' in reader) || !reader.available) return null
  if (choice === null || choice === 'other') return null
  return (reader.subjects ?? ['mathematics']).includes(choice) ? choice : null
}
